import $ from "jquery";
import {
  allowedPaymentCards,
  translationConstants,
  Directions,
  timezoneConstants,
} from "../constants";
import i18next from "i18next";
import { dateToUTCWithTimezone } from "./utility-functions";

export const unloadWidget = function () {
  if (window.wpwl !== undefined && window.wpwl.unload !== undefined) {
    window.wpwl.unload();
    $("script").each(function () {
      if (this.src.includes("paymentWidgets.js")) {
        $(this).remove();
      }
    });
  }
};

export const renderPaymentform = (
  CheckoutID,
  pathName,
  params,
  divId,
  setLoadCustomJS,
  loadCustomJSValue
) => {
  const script = document.createElement("script");
  script.src = `${process.env.REACT_APP_PAYMENT_URL}${CheckoutID}`;
  script.async = true;
  document.body.appendChild(script);

  const form = document.createElement("form");
  form.action = process.env.REACT_APP_URL + pathName + params;
  form.setAttribute("class", "paymentWidgets");
  form.setAttribute("data-brands", allowedPaymentCards);
  form.setAttribute("novalidate", true);

  const paymentSection = document.getElementById(divId);
  if (paymentSection) {
    paymentSection.innerHTML = ""; // Clear any existing content
    paymentSection.appendChild(form);
  }

  setLoadCustomJS(loadCustomJSValue);
};

export const hyperpaySaveCardFormCustomJS = (t, direction) => {
  window.wpwlOptions = {
    hideOtherPaymentButton: true,
    registrations: { requireCvv: true },
    locale: direction === Directions.rtl ? "ar" : "en",
    onReady: function () {
      //Hide the card holder name
      $(".wpwl-wrapper-registration-holder").addClass("d-none");

      //Change the column division
      $(".wpwl-wrapper-registration-brand").addClass("col-3");
      $(".wpwl-wrapper-registration-details").addClass("col-5");
      $(".wpwl-wrapper-registration-cvv").addClass("col-3");

      //Wrap the Pay Button in a new Div to center align it
      $(".wpwl-button-pay").wrap(
        `<div class="d-flex justify-content-center pt-3"> </div>`
      );

      //Change the Name of onSubmit Button
      $(".wpwl-button-pay").text(t(translationConstants.PAY_NOW));
    },
  };
};

export const hyperpayFormCustomJS = (
  t,
  direction,
  nextPayment = false,
  saveCard = false,
  isAddCard = false,
  nextBillingDueDate
) => {
  const currentDate = dateToUTCWithTimezone().add(1, "year");
  const formattedDate = `${
    nextBillingDueDate
      ? nextBillingDueDate()?.format(timezoneConstants.dayMonthYearFormat)
      : currentDate.format(timezoneConstants.dayMonthYearFormat)
  }`;

  window.wpwlOptions = {
    locale: direction === Directions.rtl ? "ar" : "en",
    //Adding Billing Address Fields
    billingAddress: {},
    mandatoryBillingFields: {
      country: true,
      state: true,
      city: true,
      postcode: true,
      street1: true,
      street2: false,
    },
    onReady: function () {
      //Add Save Card Detail Checkbox and Label
      const createRegistrationHtml = `<div class="d-flex align-items-center" id="savecard"><div class="d-flex align-items-center"><input class="form-check-input" type="checkbox" name="createRegistration" value="true" /></div> <div class="save-card-label">${t(
        translationConstants.SAVE_CARD_DETAIL
      )}</div> </div>`;
      {
        saveCard &&
          $("form.wpwl-form-card")
            .find(".wpwl-button")
            .before(createRegistrationHtml);
      }

      //Add Next Payment Due Date
      {
        nextPayment &&
          $("form.wpwl-form-card")
            .find(".wpwl-button")
            .before(
              `<div class="d-flex flex-column mb-4"><p class="font-14 fw-bold">${t(
                translationConstants.NEXT_PAYMENT_DUE_DATE
              )}: <span class="timezone-display-text">${t(
                translationConstants.TIMEZONE_DISPLAY_ON_FIELD
              )}</span></p><p id="nextPaymentDate">${formattedDate}</p></div>`
            );
      }

      //Change the Direction of card number field to ltr even if the browser is rtl
      $('iframe[name="card.number"]').addClass(
        "payment-number-field-direction"
      );

      //Change the Direction of expiry fields to ltr even if the browser is rtl
      $('input.wpwl-control-expiry[type="tel"]').addClass(
        "payment-number-field-direction"
      );

      //Change the Direction of CVV fields to ltr even if the browser is rtl
      $('iframe[name="card.cvv"]').addClass("payment-number-field-direction");

      //Wrap the Pay Button in a new Div to center align it
      $(".wpwl-button-pay").wrap(
        `<div class="d-flex justify-content-center pt-3"> </div>`
      );

      //Show Allowed Card Brands
      $(".wpwl-container-card")
        .before(`<div class="mx-0 my-2 d-flex gap-1 align-items-center justify-content-end">
          <div class="wpwl-brand wpwl-brand-MADA wpwl-brand-MADA_EN"></div>
            <div class="wpwl-brand wpwl-brand-MASTER wpwl-brand-MASTER_EN"></div>
            <div class="wpwl-brand wpwl-brand-VISA wpwl-brand-VISA_EN"></div>
            </div>`);

      //Change the Name of onSubmit Button
      $(".wpwl-button-pay").text(
        isAddCard
          ? t(translationConstants.ADD_NEW)
          : t(translationConstants.PAY_NOW)
      );

      //Change Card Holder lable
      $(".wpwl-label-cardHolder").html(
        t(translationConstants.CARD_HOLDER_NAME)
      );
      $(".wpwl-control-cardHolder").attr(
        "placeholder",
        t(translationConstants.CARD_HOLDER_NAME)
      );
      //Re-arrange the input fields.
      $(".wpwl-group-cvv").after($(".wpwl-group-expiry"));

      //Validation on the Card Holder Name field
      $(".wpwl-form-card")
        .find(".wpwl-button-pay")
        .on("click", function (e) {
          validateHolder(e);
        });

      // Change "Please select" text in the dropdown
      $("select[name='billing.country'] option[value='']").text(
        t(translationConstants.PLEASE_SELECT_COUNTRY)
      );
    },
    onBeforeSubmitCard: function (e) {
      return validateHolder(e);
    },
  };
};

function validateHolder(e) {
  var holder = $(".wpwl-control-cardHolder").val();
  if (holder.trim().length < 2) {
    $(".wpwl-control-cardHolder")
      .addClass("wpwl-has-error")
      .after(
        `<div class="wpwl-hint wpwl-hint-cardHolderError">${i18next.t(
          translationConstants.INVALID_CARD_HOLDER
        )}</div>`
      );
    return false;
  }
  return true;
}
